import { Component, ElementRef, Input, OnInit, ViewChildren} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TransferStaffAou } from '@ascschool/model/transfer/transfer-staff-aou.model';
import { TransferStaffTnService } from '@ascschool/services/transfer/transferstafftn.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Observable } from 'rxjs';
@Component({
  selector: 'chuyen-tiep-nhan-nhan-su-popup',
  templateUrl: './chuyen-tiep-nhan-nhan-su-popup.component.html',
  styleUrls: ['./chuyen-tiep-nhan-nhan-su-popup.component.scss']
})
export class ChuyenTiepNhanNhanSuPopupComponent implements OnInit {
  @ViewChildren("label") labelElement: ElementRef;
  @Input() value: any;
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  transferStaff : TransferStaffAou = new TransferStaffAou();
  errorMsg: string;
  isDisabled = false;
  validateForm = new FormGroup({
    id: new FormControl(0),
    staffId: new FormControl(null),
    staffCode: new FormControl(null),
    provinceId: new FormControl(null),
    districtId: new FormControl(null),
    transferToEatosId: new FormControl(null),
    transferDate: new FormControl(null),
    tranferType: new FormControl(null),
    transferReason: new FormControl(null),
    processingDate: new FormControl(null, Validators.required),
    processingNote: new FormControl(null)
  });
  idControl = this.validateForm.controls.id;
  staffCodeControl = this.validateForm.controls.staffCode;

  provinceControl = this.validateForm.controls.provinceId;
  districtControl = this.validateForm.controls.districtId;
  transferToEatosIdControl = this.validateForm.controls.transferToEatosId;

  transferTransferDateControl = this.validateForm.controls.transferDate;
  transferTransferReasonControl = this.validateForm.controls.transferReason;
  transferprocessingDateControl = this.validateForm.controls.processingDate;
  transferprocessingNoteControl = this.validateForm.controls.processingNote;
  
  getProvinceACFn: (value: any) => Observable<any>;
  getDistrictACFn: (value: any) => Observable<any>;
  getTransferToEatosACFn: (value: any) => Observable<any>;
  constructor(
    private modal: NzModalRef, private msg: NzMessageService, public utilsService: UtilsService,
    private service: TransferStaffTnService) {
  }

  ngOnInit() {
    this.transferStaff.id = this.value.id;
    this.idControl.setValue(this.value.id);
    this.staffCodeControl.setValue(this.value.staffCode);
    this.transferStaff.staffCode = this.value.staffCode;
    this.transferStaff.fullName = this.value.fullName;
    this.transferStaff.gender = (this.value.gender == 1 ? 'Nam' : this.value.gender == 0 ? 'Nữ' : '');
    this.transferStaff.yearOfBirth = this.value.yearOfBirth;
    this.transferStaff.typeOfPersonnelName = this.value.typeOfPersonnelName;
    this.transferStaff.positionName = this.value.positionName;
    this.transferStaff.positionGVName = this.value.positionGVName;
    this.transferStaff.provinceName = this.value.provinceName;
    this.GetById(this.value.id);

  }

  dateFormat = 'dd/MM/yyyy';
  footerRender = () => 'Ngày tiếp nhận';
  disabledDate = (current: Date): boolean => {
    let pastTime= new Date(this.transferTransferDateControl.value);
    pastTime.setDate(pastTime.getDate())

      // return current.toISOString() <= this.validateForm.controls['transferDate'].value
      return current.toISOString() < pastTime.toISOString()
  };
  GetById(id: number) {
    this.service.getTransferStaffById(id).subscribe((res: any) => {
      if (res.id > 0) {
        this.transferStaff.staffId = res.staffId;
        this.transferStaff.transferToEatosId = res.transferToEatosId;
        this.transferStaff.transferDate = res.transferDate;
        this.transferStaff.transferReason = res.transferReason;
        this.transferTransferDateControl.setValue(res.transferDate);
        this.transferTransferReasonControl.setValue(res.transferReason);
      }
    });
  }

  valueIfHas(control: AbstractControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }

  close() {
    this.destroyModal();
  }

  destroyModal(): void {
    this.modal.destroy(true);
  }

  Receive() {
    if (this.validateForm.valid) {
        this.validateForm.get('staffId').setValue(this.transferStaff.staffId);
        this.validateForm.get('tranferType').setValue(2);
      this.service.updatetransferStaff(this.bindOfDataId(this.validateForm)).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    } else {
      this.utilsService.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }
  }

  NoAccept() {
    if (this.validateForm.valid) {
        this.validateForm.get('staffId').setValue(this.transferStaff.staffId);
        this.validateForm.get('tranferType').setValue(3);
      this.service.updatetransferStaff(this.bindOfDataId(this.validateForm)).subscribe((res) => {
        if (res.statusCode === 0) {
          this.notification(res);
          this.close();
        } else {
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    } else {
      this.utilsService.showNotifyInvalidControls(this.validateForm, this.labelElement);
    }
  }
  
  //
  bindOfDataId(formGroup: FormGroup) {
    let data;
    data = formGroup.value;
    const controls = formGroup.controls;
    for (const name in controls) {
      if (data[name] && data[name].id) {
        data[name] = data[name].id
      }
    }
    return data;
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin: ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
    
  }

  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));

    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
}
